import Vue from "vue";
import VueRouter from "vue-router";
import Intro from "../views/Intro.vue";
import Start from "../views/Start.vue";
import ForMarkOnly from "../views/ForMarkOnly.vue";
import Invitation from "../views/Invitation.vue";
import DeepInfo from "../views/DeepInfo/DeepInfo.vue";
import DeepInfoOffer from "../views/DeepInfo/InfoOffer.vue";
import DeepInfoGeneral from "../views/DeepInfo/InfoGeneral.vue";
import DeepInfoConcept from "../views/DeepInfo/InfoConcept.vue";
import DeepInfoProcess from "../views/DeepInfo/InfoProcess.vue";
import QuickMenu from "../views/QuickMenu.vue";
import Contact from "../views/Contact.vue";
import NotFoundComponent from "../views/NotFoundComponent.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Intro",
    component: Intro
  },
  {
    path: "/start",
    name: "Start",
    component: Start
  },
  {
    path: "/quick-menu",
    name: "QuickMenu",
    component: QuickMenu
  },
  {
    path: "/for-mark-only",
    name: "ForMarkOnly",
    component: ForMarkOnly
  },
  {
    path: "/invitation",
    name: "Invitation",
    component: Invitation
  },
  {
    path: "/deep-info",
    name: "DeepInfo",
    component: DeepInfo
  },
  {
    path: "/deep-info/what-does-blissing-offer",
    name: "DeepInfoOffer",
    component: DeepInfoOffer
  },
  {
    path: "/deep-info/general-information",
    name: "DeepInfoGeneral",
    component: DeepInfoGeneral
  },
  {
    path: "/deep-info/concept-information",
    name: "DeepInfoConcept",
    component: DeepInfoConcept
  },
  {
    path: "/deep-info/profit-and-process",
    name: "DeepInfoProcess",
    component: DeepInfoProcess
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  { path: "*", component: NotFoundComponent }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
